<template>
  <div>
    <modal v-model="editorVisible">
      <div class="large-dialog">
        <div class="large-dialog-header">
        </div>
        <div class="large-dialog-body">
          <div class="locs-labels">
            <ul>
              <li>Nuclear</li>
              <li>Cortical</li>
              <li>Posterior</li>
            </ul>
          </div>
          <div class="locs-eyes" v-for="(eye, index) in observations" :key="index">
            <h2 class="contrast">{{ eye.laterality === 'right' ? 'OD' : 'OS' }}</h2>
            <div class="locs-selector">
              <div class="nuclear-selector">
                <div v-for="level in locs.nuclear" :key="level.grade">
                  <a href="#" class="nuclear-selection" @click.prevent="selectGrade(index,level.grade)">
                    <img v-bind:class="[{'nuclear-color': isNuclearColor(level.grade)},{selected: isSelected(index,level.grade)}]" v-bind:src="'/static/images/LOCSiii/'+level.image" height="67px" width="34px"/>
                    <span class="nuclear-grade-label">{{level.grade}}</span>
                  </a>
                </div>
              </div>
              <div class="cataract-selector">
                <div v-for="level in locs.cortical" :key="level.grade">
                  <a href="#" class="cortical-selection" @click.prevent="selectGrade(index,level.grade)">
                    <img v-bind:class="{selected: isSelected(index,level.grade)}" v-bind:src="'/static/images/LOCSiii/'+level.image" height="67px" width="68px"/>
                    <span class="grade-label">{{level.grade}}</span>
                  </a>
                </div>
              </div>
              <div class="cataract-selector">
                <div v-for="level in locs.posterior" :key="level.grade">
                  <a href="#" class="posterior-selection" @click.prevent="selectGrade(index,level.grade)">
                    <img v-bind:class=" {selected: isSelected(index,level.grade)}" v-bind:src="'/static/images/LOCSiii/'+level.image" height="67px" width="68px"/>
                    <span class="grade-label">{{level.grade}}</span>
                  </a>
                </div>
              </div>
              <div class="locs-results">
                <div class="result" v-for="(score,category) in eye.value" :key="category">
                  <input class="result-score" v-model="eye.value[category]">
                  <span class="result-label">{{ category }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div class="float-left w-96" v-for="(eye, index) in observations" :key="index">
      <div class="flex">
        <div class="px-2" v-for="(score,category) in eye.value" :key="category">
          <input class="w-10 border-solid border-2 border-gray-500 text-gray-700 text-2xl pl-3" v-model="eye.value[category]">
          <span class="w-10 absolute block text-center text-sm">{{ category }}</span>
        </div>
      </div>
    </div>
    <button v-if="!editorVisible" class="bg-gray-700 hover:bg-orange-800 text-white font-bold py-2 px-4 rounded" @click="editorVisible = true">Open LOCSiii panel</button>
  </div>
</template>
<script>
// import getSystemCode from '../utils/system'
import Modal from '@/components/Modal.vue'

export default {
  components: { Modal },
  data () {
    return {
      editorVisible: false,
      // eyes: {
      //   OD: { NO: '', NC: '', C: '', P: '' },
      //   OS: { NO: '', NC: '', C: '', P: '' }
      // },
      locs: {
        nuclear: [
          { image: 'NO1.jpg', grade: 'NO1' },
          { image: 'NC1.jpg', grade: 'NC1' },
          { image: 'NO2.jpg', grade: 'NO2' },
          { image: 'NC2.jpg', grade: 'NC2' },
          { image: 'NO3.jpg', grade: 'NO3' },
          { image: 'NC3.jpg', grade: 'NC3' },
          { image: 'NO4.jpg', grade: 'NO4' },
          { image: 'NC4.jpg', grade: 'NC4' },
          { image: 'NO5.jpg', grade: 'NO5' },
          { image: 'NC5.jpg', grade: 'NC5' },
          { image: 'NO6.jpg', grade: 'NO6' },
          { image: 'NC6.jpg', grade: 'NC6' }
        ],
        cortical: [
          { image: 'C1.jpg', grade: 'C1' },
          { image: 'C2.jpg', grade: 'C2' },
          { image: 'C3.jpg', grade: 'C3' },
          { image: 'C4.jpg', grade: 'C4' },
          { image: 'C5.jpg', grade: 'C5' }
        ],
        posterior: [
          { image: 'P1.jpg', grade: 'P1' },
          { image: 'P2.jpg', grade: 'P2' },
          { image: 'P3.jpg', grade: 'P3' },
          { image: 'P4.jpg', grade: 'P4' },
          { image: 'P5.jpg', grade: 'P5' }
        ]
      },
      observations: [
        {
          bodySite: {},
          code: 'locsiii_od',
          coding: [
            { code: 'locsiii_od' },
            { display: 'LOCSIII (OD)' },
            { system: 'clinres' }
          ],
          laterality: 'right',
          value: { NO: '', NC: '', C: '', P: '' }
        },
        {
          bodySite: {},
          code: 'locsiii_os',
          coding: [
            { code: 'locsiii_os' },
            { display: 'LOCSIII (OS)' },
            { system: 'clinres' }
          ],
          laterality: 'left',
          value: { NO: '', NC: '', C: '', P: '' }
        }
      ]
    }
  },
  methods: {
    // getSystemCode, // imported from utils/system.js
    // check if the grade is Nuclear Color (NC) - for dynamic CSS
    isNuclearColor (grade) {
      return grade.charAt(1) === 'C'
    },
    // check if the image is currently selected - for dynamic CSS
    isSelected (eyeIndex, grade) {
      const category = grade.slice(0, grade.length - 1)
      const score = grade.slice(-1)
      return this.observations[eyeIndex]['value'][category] === score
    },
    // toggle selection of grade
    selectGrade (eyeIndex, grade) {
      const category = grade.slice(0, grade.length - 1)
      const score = grade.slice(-1)
      // unselect
      if (this.observations[eyeIndex]['value'][category] === score) {
        this.observations[eyeIndex]['value'][category] = ''
      } else {
        // select
        this.observations[eyeIndex]['value'][category] = score
      }
    }
  }
}
</script>
<style scoped>
h2.contrast{
  color: #BDC7D8;
}
.large-dialog {
  background-color: #565656;
  width: 980px
}
.locs-labels {
  background-color: #000000;
  color: #CCCCCC;
  float: left;
  margin-top: 73px;
  width: 105px;
}
.locs-labels ul li {
  line-height: 550%;
}
.locs-eyes {
  float: left;
  width: 435px;
}
.locs-selector a:hover img, img.selected {
  border: 2px solid;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.nuclear-selector {
  background-color: #000000;
  display: grid;
  grid-template-columns: repeat(12, 34px);
  grid-template-rows: 90px;
  padding-top: 20px;
}
a.nuclear-selection:hover img.nuclear-color, a.nuclear-selection img.nuclear-color  {
  border-color: #33E653;
}
.nuclear-grade-label {
  color: #AAAAAA;
  font-size: 0.8em;
  position: relative;
  top: -5px;
}
a:hover span.nuclear-grade-label {
  color:#FFFFFF;
}
.cataract-selector {
  background-color: #000000;
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(12, 78px);
  grid-template-rows: 90px;
  padding-bottom: 3px;
}
a.cortical-selection:hover img, .cortical-selection img.selected {
  border-color: #FFF333
}
a.posterior-selection:hover img, .posterior-selection img.selected {
  border-color: #FF5733
}
.grade-label {
  color: #999999;
  position: relative;
  top: -5px;
}
.cataract-selector a:hover span.grade-label {
  color:#FFFFFF;
}
.locs-results {
  padding-left: 100px;
}
.result {
  float: left;
  height: 60px;
  width: 50px;
  padding: 25px 5px 0 5px;
}
.result input {
  background-color: #454545;
}
.result-score {
  border: 1px solid #CCCCCC;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  color: #DDDDDD;
  padding-left: 10px;
  font-size: 2em;
  width: 40px;
}
.result-label {
  color: #CCCCCC;
  font-size: 1.2em;
  position: relative;
  top: 10px;
}
</style>
